// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"930ea36d","498":"34b510af","703":"4642bc05","787":"02c13cb2"}[chunkId] + ".chunk.js";
};